module.exports = __webpack_public_path__ + "static/media/DASHPORT_white_horizontal.8fc239f8.png";